<template lang="">
  <div>
    <el-form label-width="130px" ref="ruleForm" :rules="rules" :model="form">
      <!-- <el-form-item label="产品小图">
        <uploadPicView :data="data"  />
      </el-form-item> -->
      <el-form-item label="产品图片" prop="flag">
        <el-row style="position: relative;">
            <template v-for="(rowItem,rowIndex) in rowNum">
              <div :key="'row'+rowIndex" style="margin:10px;height: 155px;">
                <el-col style="margin-right:30px"  :span="5" v-for="(item,index) in data.outPicList.slice(rowIndex*colNum,((rowIndex+1)*colNum))" :key="item.id">
                  <uploadItemPic :item="item" :data="data" :index="(rowIndex*colNum+index)" :list="data.outPicList"/>
                </el-col>
              </div>
            </template>
            <div v-if="data.outPicList.length < 10" @click="addPic"  class="el-icon-plus avatar-uploader-icon"/>
        </el-row>
      </el-form-item>
  </el-form>
  </div>
</template>
<script>
import uploadItemPic from '@/components/product_control/addProductDialog/uploadItemPic'
export default {
  props: {
    data: {
      type: Object
    },
    businessType: {
      type: String
    }
  },
  data () {
    return {
      colNum: 4, // 每行显示的个数
      form: {
        flag: true// 只是为了给产品小图一个星号
      },
      rules: {
        flag: [
          { required: true, message: '请选择图片', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    rowNum: {
      get () {
        return Math.ceil(this.data.outPicList.length / this.colNum)
      },
      set (val) {
        // this.rowNum = val
      }
    }
  },
  components: {
    uploadItemPic
  },
  created () {
    console.log('产品：', this.data);
  },
  methods: {
    addPic () {
      if (this.data.outPicList.length > 9) {
        return
      }
      const item = {
        id: new Date().getTime() + Math.random(),
        fileName: '',
        fileToken: '',
        fileDesc: '',
        businessType: this.businessType//  业务类型(0:ios；1:安卓；2:中控面板；3:协议文件；4:其他)
      }
      this.data.outPicList.push(item)
      this.rowNum = Math.ceil(this.data.outPicList.length / this.colNum)
    }
  }
}
</script>
<style lang='less' scoped>
.el-icon-plus {
  position: absolute;
  right: 20px;
  top: 0px
}
/deep/ .el-upload{
  border: 1px dashed #d9d9d9;
}
/deep/.avatar-uploader {
    width: 100px;
    height: 100px;
}
/deep/.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar-uploader-icon {
     font-size: 14px;
    color:white;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color:#409EFF;
    border-radius: 25px;
    cursor: pointer;
  }
</style>
